import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Routes, RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { ServicePage } from './service.page';
import { MenuPageModule } from '../menu/menu.module';
import { TranslateModule } from '@ngx-translate/core';

const routes: Routes = [
    {
        path: 'service1',
        component: ServicePage
    }
];

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        RouterModule.forChild(routes),
        MenuPageModule,
        TranslateModule
    ],
    declarations: [ServicePage],
    exports: [ServicePage]
})
export class ServicePageModule {}
